module.exports = __webpack_public_path__ + "img/5.114f8a2e.png";